import { useSelector } from "react-redux";
import {
  deleteFiles as deleteFilesService,
  presigneUrl as presigneUrlService,
  uploadFile as uploadFileService,
} from "../../services/upload/upload.service";
import { handlerErrorV2 } from "../../utils/errors";
import globalConfig from "../../config/globalConfig";

const useUpload = () => {
  const tenantId = useSelector(state => state?.tenant?.tenant?.tenantId || null);

  const srcFile = (src) => {
    return `${globalConfig.storage || window.location.origin}/tenants/${tenantId}/${src}`
  }

  const deleteFiles = async (data = [], type = "public") => {
    try {
      const files = data.map((file) => ({ name: file }));
      const result = await deleteFilesService(files, type);
      if (result.error) {
        return { error: result?.error?.message || "Something went wrong. Please try again." };
      }
    
      return { error: null, data: result.data };
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: message };
    }
  };

  const uploadFile = async (files = [], type = "public") => {
    try {
      const resultUpload = await presigneUrlService(files, type);
      if (resultUpload.error || !resultUpload.data) {
        return { error: resultUpload.error.message };
      } else {
        const result = await Promise.all(
          resultUpload.data.map(async (file) => {
            const { data, error } = file;
            if (!data) {
              return {
                name: error.file,
                error: error?.msg || "Something went wrong. Please try again.",
              };
            }
            const currentFile = files.find((item) => item.id === data?.file?.id);
            if (currentFile) {
              await uploadFileService(data.presignedUrl, currentFile.file);
              return {
                id: data.file.id,
                name: data.filename,
                link: `${type}/${data.filename}`,
              };
            }

            return {
              id: data.file.id,
              error: 'File not found'
            };
            
          })
        );

        if (!result) {
          return { error: "Something went wrong. Please try again." };
        } else {
          return { error: null, data: result };
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: message };
    }
  };

  return {
    deleteFiles,
    uploadFile,
    srcFile
  };
};

export default useUpload;
